import {Component, OnDestroy, OnInit} from '@angular/core';
import {InformType} from '../../../../global/util/enum/InformType';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {AddEditPersonComponent} from '../add-edit-person/add-edit-person.component';
import {Person} from '../../../model/Person';
import {PersonService} from '../../../service/person.service';
import {DeletePersonComponent} from '../delete-person/delete-person.component';
import {Page} from '../../../../global/util/enum/Page';
import {Constant} from '../../../../global/util/Constant';
import {LocalStorage} from '../../../../global/util/LocalStorage';
import {AuthService} from '../../../service/auth/auth.service';
import {AssignWorkflowPersonComponent} from '../assign-workflow-person/assign-workflow-person.component';
import {WorkflowService} from '../../../service/workflow.service';
import {ConfirmComponent} from '../../../../shared/confirm/confirm.component';
import {Response} from '../../../../global/util/enum/Response';
import {AssignAuthorityRoleComponent} from '../../role/assign-authority-role/assign-authority-role.component';
import {Authority} from '../../../model/Authority';
import {AuthorityService} from '../../../service/authority.service';
import {CloneTool} from '../../../../global/util/CloneTool';
import {Enterprise} from '../../../model/Enterprise';
import {Partner} from '../../../model/Partner';
import {Dialog} from '../../../../global/util/Dialog';
import {AddPeopleBatchComponent} from '../add-people-batch/add-people-batch.component';
import {Role} from '../../../model/Role';
import {ApplicationService} from '../../../service/application.service';
import {TranslateService} from '@ngx-translate/core';
import {Pagination} from '../../../../global/util/Pagination';
import {EnterpriseService} from '../../../service/enterprise.service';
import {EnterpriseDataService} from '../../../service/data/enterprise-data.service';
import {of} from 'rxjs';

@Component({
  selector: 'app-list-person',
  templateUrl: './list-person.component.html',
  styleUrls: ['./list-person.component.css']
})
export class ListPersonComponent implements OnInit, OnDestroy {
  public person: Person;
  public people: any[] = [];
  public loading: boolean;
  public title = 'TITLE.PERSON';
  public page: any = {};
  public links: any = {};
  public enumPage = Page;
  private personUrl: string;
  public enterprises: Enterprise[] = [];
  public partners: Partner[] = [];
  public participantTypes: any[] = [];
  public roles: Role[] = [];
  public roleSelected: any;
  public enterpriseIdSelected: number;
  public enterpriseSelected: Enterprise;
  public partnerSelected: Partner;
  public participantTypeSelected: any;
  public ROLE_SUPERADMIN = Constant.ROLE_SUPERADMIN;
  public ROLE_PARTNER = Constant.ROLE_PARTNER;
  public ROLE_ADMIN = Constant.ROLE_ADMIN;
  public ROLE_ADMIN_NOTCER = Constant.ROLE_ADMIN_NOTCER;
  public ROLE_USER = Constant.ROLE_USER;
  public OPTION_ADD = Constant.ADD;
  public OPTION_EDIT = Constant.EDIT;
  public term2Search;
  pageNumber: any;
  pageNumbers: any = [];

  constructor(private modalService: NgbModal,
              private personService: PersonService,
              private authenticationService: AuthService,
              private workflowService: WorkflowService,
              private authorityService: AuthorityService,
              private applicationService: ApplicationService,
              private enterpriseService: EnterpriseService,
              private enterpriseDataService: EnterpriseDataService,
              private translate: TranslateService) {
    Dialog.createInstance(modalService);
  }

  ngOnInit() {
    this.pageNumbers = Pagination.getNumbers();
    this.pageNumber = this.pageNumbers[0].value;
    this.enterprises = LocalStorage.getDefaultEnterprise();
    this.enterpriseSelected = this.enterprises[Constant.ZERO_INDEX];
    this.setDefaultData();
    this.loadPeople(Page.First);
  }

  ngOnDestroy(): void {
    LocalStorage.removeItem('roles');
  }

  private setDefaultData() {
    this.participantTypes = LocalStorage.getParticipantTypesExtra();
    this.participantTypeSelected = this.participantTypes[Constant.ZERO_INDEX];
    this.roles = LocalStorage.getRolesExtra();
    this.roleSelected = this.roles[Constant.ZERO_INDEX];
    if (this.hasRole(this.ROLE_SUPERADMIN)) {
      this.partners = LocalStorage.getPartnersExtra();
      if (!this.partners || this.partners.length === 0) {
        return of(void 0);
      }
      this.partnerSelected = this.partners[Constant.ZERO_INDEX];
      this.getAllEnterprisesBy();
    }

    if (this.hasRole(this.ROLE_PARTNER)) {
      const partnerId = LocalStorage.getPartnerId();
      this.getEnterprisesByPartner(partnerId);
    }

    // ADMIN / ADMIN_NOTCER / USER
    this.enterpriseIdSelected = this.authenticationService.getEnterpriseIdView();
    return of(void 0);
  }

  public reloadPeople1() {
    if (this.enterpriseSelected) {
      this.enterpriseIdSelected = this.enterpriseSelected.id;
    }
    this.people = [];
    this.loadPeople(Page.First);
  }

  public loadPeople(page: Page) {
    if (this.term2Search === undefined) {
      this.term2Search = '';
    }
    switch (page) {
      case Page.First:
        let partnerId;
        if (this.hasRole(this.ROLE_SUPERADMIN)) {
          partnerId = this.partnerSelected.id;
        } else {
          partnerId = LocalStorage.getPartnerId();
        }
        let enterpriseId;
        if (!this.hasRole(this.ROLE_SUPERADMIN) && !this.hasRole(this.ROLE_PARTNER)) {
          enterpriseId = this.authenticationService.getEnterpriseIdView();
        } else {
          enterpriseId = this.enterpriseSelected?.id ?? 0;
        }
        this.personUrl = Constant.ROOT_API_V1
          .concat('/partners/')
          .concat(String(partnerId))
          .concat('/enterprises/')
          .concat(String(enterpriseId))
          .concat('/roles/')
          .concat(this.roleSelected.id)
          .concat('/participanttypes/')
          .concat(String(this.participantTypeSelected.id))
          .concat('/people')
          .concat('?findby=')
          .concat(this.term2Search)
          .concat('&size=')
          .concat(this.pageNumber)
          .concat('&sort=id,desc');
        break;
      case Page.Previous:
        this.personUrl = this.links.prev.href.replace('http', Constant.SCHEMA);
        break;
      case Page.Next:
        this.personUrl = this.links.next.href.replace('http', Constant.SCHEMA);
        break;
      case Page.Last:
        this.personUrl = this.links.last.href.replace('http', Constant.SCHEMA);
        break;
      default:
        this.personUrl = this.links.self.href.replace('http', Constant.SCHEMA);
        break;
    }
    this.loading = true;
    this.personService.get(this.personUrl).subscribe((next: any) => {
      this.loading = false;
      if (next._embedded) {
        this.people = next._embedded.people;
        this.page = next.page;
        this.links = next._links;
      } else {
        this.people = [];
        this.page.totalElements = 0;
      }
    }, () => {
      this.loading = false;
      Dialog.show(InformType.Danger, this.translate.instant('TITLE.PERSON'));
    });
  }

  public openModalAddBatch() {
    this.loading = true;
    // this.loadEnterprisesToModal();
    this.loading = false;
    const modalRef = this.modalService.open(AddPeopleBatchComponent, {
      backdrop: 'static',
      size: 'lg'
    });
    modalRef.result.then((result) => {
      const informType = result.informType;
      if (InformType.Success === informType) {
        const people: Person[] = result.people;
        const updated = people.filter(value => value.found).length;
        const registered = people.filter(value => !value.found).length;
        let message;
        if (updated > 0 && registered === 0) {
          message = String(this.translate.instant('MESSAGE.UPDATE-DATA-OF-PERSONS')).replace('%s', String(updated));
        } else if (updated === 0 && registered > 0) {
          message = String(this.translate.instant('MESSAGE.REGISTERED-DATA-OF-PERSONS')).replace('%s', String(registered));
        } else if (updated > 0 && registered > 0) {
          message = String(this.translate.instant('MESSAGE.REGISTERED-AND-UPDATE-DATA-OF-PERSONS')).replace('%s', String(registered));
          message = message.replace('%s1', String(updated));
        }
        this.loadPeople(Page.Self);
        Dialog.show(InformType.Success, this.translate.instant('TITLE.MASSIVE-REGISTRATION-PEOPLE'), message);
      } else if (InformType.Danger === informType) {
        const message = result.message;
        Dialog.show(InformType.Danger, this.translate.instant('TITLE.MASSIVE-REGISTRATION-PEOPLE'), message);
      }
    });
  }

  public delete(person: Person) {
    this.title = this.translate.instant('TITLE.PERSON');
    const modalRef = this.modalService.open(DeletePersonComponent, {
      backdrop: 'static'
    });
    modalRef.componentInstance.person = person;
    modalRef.componentInstance.enterpriseIdSelected = this.enterpriseIdSelected;
    modalRef.result.then((result) => {
      if (InformType.Success === result) {
        this.loadPeople(Page.Self);
        Dialog.show(InformType.Success, this.title);
      } else if (InformType.Danger === result) {
        Dialog.show(InformType.Danger, this.title);
      }
    });
  }

  /**
   * Carga los datos necesarios para el módulo actual y luego abre el modal para agregar/editar persona
   */
  public loadRequiredDataAndOpenModal(option: number, person?: Person) {
    this.loading = true;
    // this.loadEnterprisesToModal();
    const url = Constant.ROOT_API_V1.concat('/required-data?component=add-person');
    this.applicationService.get(url).subscribe((next: any) => {
      this.loading = false;
      LocalStorage.setUpEmbeddedInfo(next);
      this.openModalAddEditModal(option, person);
    }, () => {
      this.loading = false;
      Dialog.show(InformType.Danger, this.translate.instant('TITLE.PERSON'));
    });
  }

  private openModalAddEditModal(option: number, person: Person) {
    const p = Constant.ADD === option ? new Person() : CloneTool.do(person);
    // this.loadEnterprisesToModal();
    this.title = this.translate.instant('TITLE.PERSON');
    const modalRef = this.modalService.open(AddEditPersonComponent, {
      backdrop: 'static',
      size: 'lg'
    });
    modalRef.componentInstance.purpose4Form = option;
    modalRef.componentInstance.personReceived = p;
    modalRef.result.then((result) => {
      if (InformType.Success === result) {
        this.loadPeople(Page.First);
        Dialog.show(InformType.Success, this.title);
      } else if (InformType.Warning === result) {
        Dialog.show(InformType.Warning, this.title);
      } else if (InformType.Danger === result) {
        Dialog.show(InformType.Danger, this.title);
      }
    });
  }

  public openModalResetPassword(person: Person) {
    const modalRef = this.modalService.open(ConfirmComponent, {
      backdrop: 'static'
    });
    modalRef.componentInstance.title = this.translate.instant('TITLE.RESET-PASSWORD');
    modalRef.componentInstance.body = this.translate.instant('QUESTION.ARE-YOU-SURE-RESET-PASSWORD');
    modalRef.result.then((result) => {
      if (Response.Yes === result) {
        this.resetPassword(person);
      }
    });
  }

  private resetPassword(person: Person) {
    this.loading = true;
    this.title = this.translate.instant('TITLE.PERSON');
    const resetPassUrl = Constant.ROOT_API_V1.concat('/people/').concat(String(person.id)).concat('/resetpassword');
    this.personService.resetPassword(resetPassUrl).subscribe(() => {
      this.loading = false;
      Dialog.show(InformType.Success, this.title);
    }, () => {
      this.loading = false;
      Dialog.show(InformType.Danger, this.title);
    });
  }

  public openModalAssignWorkflow(person: Person) {
    this.loading = true;
    let workflows: any[] = [];
    const url = Constant.ROOT_API_V1
      .concat('/people/')
      .concat(String(person.id))
      .concat('/workflows');
    this.workflowService.get(url).subscribe((value: any) => {
      this.loading = false;
      if (value._embedded) {
        workflows = value._embedded.workflows;
      }
      const modalRef = this.modalService.open(AssignWorkflowPersonComponent, {
        backdrop: 'static',
      });
      const workflows1 = CloneTool.doList(workflows);
      this.title = this.translate.instant('TITLE.PERSON');
      modalRef.componentInstance.personReceived = person;
      modalRef.componentInstance.selectedWorkflows = workflows;
      modalRef.componentInstance.selectedWorkflowsDB = workflows1;
      modalRef.result.then((result) => {
        if (InformType.Success === result) {
          Dialog.show(InformType.Success, this.title);
        } else if (InformType.Danger === result) {
          Dialog.show(InformType.Danger, this.title);
        }
      });
    }, () => {
      Dialog.show(InformType.Danger, this.title);
    });
  }

  public hasRole(roleDescription: string) {
    return this.authenticationService.hasRole(roleDescription);
  }

  get isInvited(): boolean {
    return Constant.INVITED === this.participantTypeSelected.id;
  }

  public openModalAssignMoreAuthorities(person: Person) {
    this.loadSelectedAuthoritiesBy(person);
  }

  private loadSelectedAuthoritiesBy(person: Person) {
    this.loading = true;
    const url = Constant.ROOT_API_V1
      .concat('/people/')
      .concat(String(person.id))
      .concat('/authorities');
    this.authorityService.get(url).subscribe((next: any) => {
      this.loading = false;
      let selectedAuthorities = [];
      if (next._embedded) {
        selectedAuthorities = next._embedded.authorities;
      }
      this.showModalAssignAuthorities(person, selectedAuthorities);
    }, () => {
      this.loading = false;
      Dialog.show(InformType.Danger, this.translate.instant('TITLE.PERSON'));
    });
  }

  public hasAuthority(code: string): boolean {
    return this.authenticationService.hasAuthority(code);
  }

  public search() {
    this.reloadPeople1();
  }

  private showModalAssignAuthorities(person: Person, authorities: Authority[]) {
    this.title = this.translate.instant('TITLE.PERSON');
    const modalRef = this.modalService.open(AssignAuthorityRoleComponent, {
      backdrop: 'static',
      size: 'lg'
    });
    modalRef.componentInstance.selectedAuthorities = authorities;
    modalRef.componentInstance.modeAssign = Constant.USER_AUTHORITY_MODE;
    modalRef.componentInstance.person = person;
    modalRef.result.then((result) => {
      if (InformType.Success === result) {
        Dialog.show(InformType.Success, this.title);
      } else if (InformType.Danger === result) {
        Dialog.show(InformType.Danger, this.title);
      }
    });
  }

  public reloadPeople0() {
    this.getEnterpriseBy(this.partnerSelected.id);
  }

  private getAllEnterprisesBy() {
    this.enterpriseService.getAllEnterprises().subscribe(enterprises => {
      const enterpriseFilter = enterprises.filter(value => value.partnerId === this.partnerSelected.id);
      this.enterprises = LocalStorage.addEnterprise(enterpriseFilter).sort();
      this.enterpriseDataService.setEnterprises(enterprises.sort());
      if (this.enterprises.length > 0) {
        this.enterpriseSelected = this.enterprises[Constant.ZERO_INDEX];
        this.enterpriseIdSelected = this.enterpriseSelected.id;
      }
    });
  }


  private getEnterprisesByPartner(partnerId: number) {
    this.enterpriseService.getEnterprisesByPartner(partnerId).subscribe(enterprises => {
      this.enterprises = enterprises.sort();
      this.enterpriseDataService.setEnterprises(this.enterprises);
      if (this.enterprises.length > 0) {
        this.enterpriseSelected = this.enterprises[Constant.ZERO_INDEX];
        this.enterpriseIdSelected = this.enterpriseSelected.id;
      }
    });
  }

  /**
   * Filtra la empresa al seleccionar el partner
   * @param id
   * @private
   */
  private getEnterpriseBy(id: number): void {
    const enters = this.enterpriseDataService.getEnterprises();
    if (this.hasRole(this.ROLE_SUPERADMIN)) {
      if (id === Constant.ALL_PARTNER_ID) {
        this.enterprises = LocalStorage.getDefaultEnterprise();
      }
      const enterprisesFilter = enters.filter(value => id === value.partnerId);
      this.enterprises = LocalStorage.addEnterprise(enterprisesFilter);
      this.reloadPeople1();
    }
  }
}
